import { render, staticRenderFns } from "./signup-dialog.vue?vue&type=template&id=351dc658&scoped=true"
import script from "./signup-dialog.vue?vue&type=script&lang=js"
export * from "./signup-dialog.vue?vue&type=script&lang=js"
import style0 from "./signup-dialog.vue?vue&type=style&index=0&id=351dc658&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351dc658",
  null
  
)

export default component.exports